import { FC } from 'react'
import {
  Avatar,
  useAssignment,
  useGlobalState,
  MarkFavourite,
} from '@pepper/ui'
import { StarFilled } from '@ant-design/icons'
import clsx from 'clsx'
import { StringParam, useQueryParam } from 'use-query-params'
import { useSelectedCompanyId } from 'utils/functions/misc'

import styles from './_.module.css'

interface Props {
  data?: Record<string, any>
  refetch: () => void
}

const ProfilePreviewCard: FC<Props> = ({ data, refetch }) => {
  const assignmentIdFromParams = useQueryParam(
    'view_assignment',
    StringParam
  )[0]
  const { assignmentRefetchFunction } = useGlobalState()
  const companyId = useSelectedCompanyId()
  const assignmentId = assignmentIdFromParams ?? ''
  const fetchAssignmentData = useAssignment({ assignmentId })

  return (
    <div className={styles.profileCard}>
      <div className={styles.header}>
        <div className={styles.profile}>
          <Avatar
            className={styles.avatar}
            nameChar={data?.full_name}
            src={data?.avatar}
          >
            {data?.full_name}
          </Avatar>
          <div className={styles.profileNameMargin}>
            <span className={styles.profileName}>
              {data?.display_name || data?.first_name}
            </span>
            <span>
              <StarFilled
                className={clsx(styles.profileRating, {
                  [styles.profileRatingNA]:
                    Number(data?.stats?.average_feedback_score) < 4,
                })}
              />
              {data?.stats?.average_feedback_score >= 4 ? (
                <span className={styles.profileTags}>
                  {data?.stats?.average_feedback_score}{' '}
                </span>
              ) : (
                <span className={styles.profileNoRating}>
                  Not enough ratings
                </span>
              )}
            </span>
            <span className={styles.markFavButton}>
              {data && (
                <MarkFavourite
                  creator={{
                    id: data?.id ?? '',
                    name: data?.display_name ?? 'Creator',
                    role: data?.role ?? '',
                    isFavourite: data?.is_favourite_creator ?? false,
                  }}
                  small={true}
                  onSucess={() => {
                    fetchAssignmentData.refetch()
                    assignmentRefetchFunction?.()
                  }}
                  isDisabled={
                    data.is_blacklist_creator ||
                    data.availability_status === 'removed'
                  }
                  companyId={companyId}
                />
              )}
            </span>
            <div className={styles.profileRole}>{data?.headline}</div>
          </div>
        </div>
      </div>
      {/* below part hidden till next release */}
      {/* <div className={styles.profileDataContainer}>{data?.description}</div>
        <div className={styles.profileDataContainer}>
          {data?.genres?.length > 0 ? (
            <div className={styles.profileDataContainer}>
              <div className={styles.profileDataHeader}>
                Expertise & Industry
              </div>
              <div className={styles.profileTagWrap}>
                {data?.genres.map((i: UserGenre) => (
                  <div key={i.id} color="default" className={styles.profileTag}>
                    {i.name}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            ''
          )}
        </div> */}
    </div>
  )
}

export default ProfilePreviewCard
